import keys from 'constants/keys'

const NEUTRAL_COLORS = { bg: '#F8FAFC', border: '#E5E8EB', text: '#5B6570' }

/** Dashboard and execution use the same rounded score and configured tier colors. */
export function getAiScorePresentation(value?: number | null) {
  const score =
    typeof value === 'number' && Number.isFinite(value) ? Math.max(0, Math.min(100, Math.round(value))) : undefined
  const tier =
    score === undefined
      ? undefined
      : keys.AI_SCORE_TIERS.find((item) => score >= item.minScore && score <= item.maxScore)

  return { score, tier, colors: tier || NEUTRAL_COLORS }
}
